export default "__VITE_ASSET__C5jiAYO___"